<template>
    <div class="login">
      <div class="left-wrap">
       <svg class="icon" aria-hidden="true">
          <use xlink:href="#iconzhaopian-copy"></use>
        </svg>
   
       <img class="left-img" src="@/assets/img/lf_icon.png"/>
      </div>
	  <div class="right-wrap">
	    <div class="header">
	      <svg class="icon" aria-hidden="true">
	        <use xlink:href="#iconzhaopian-copy"></use>
	      </svg>
	      <h1>智能终端管理平台</h1>
	    </div>
			<el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-wrap">
	      <div class="form">
	        <h3>智能终端管理平台</h3>
	        <el-col style="margin-top: 30px">
	          <span class="input-label">账号</span>
	          <el-input placeholder="请输入账号" size="medium" v-model.trim="loginForm.accountName" />
              <div class="showRememberAccount" v-if="showAccountsPanel">
                    <RememberAccount @func="getAccountFormSon" ></RememberAccount>
                </div>
	        </el-col>
	        <el-col style="margin-top: 15px">
	          <span class="input-label">密码</span>
	          <el-input placeholder="请输入密码" v-model.trim="loginForm.pwd" size="medium" type="password"
	            autocomplete="off"
	            show-password
	          />
	        </el-col>
			<el-col style="margin-top: 10px;display: flex;align-items: center;">
				<el-checkbox style="width:20px; height:5px;" v-model="rememberMe">保存账号</el-checkbox>
			     <el-button 
				  style="margin-left: auto;"
				  @click="findPass();return false;" target="_blank">忘记密码</el-button>
			</el-col>
	        <el-col style="margin-top: 30px">
	          <el-button class="login-btn"  @click.prevent = "handleLogin">
	            立即登陆
	          </el-button>
	        </el-col>
	      </div>
		  </el-form>
	  </div>
        <el-dialog title="忘记密码" :visible.sync="findPassWold"  width="600px" :show-close="false">
                <p style="color: #fd5353; text-align: center; margin-bottom: 20px;">{{modifyPwdTip}}</p>
                <el-form ref="modifyPwdForm" :model="modifyPwdForm" :rules="pwdRules" label-width="100px">
                    <el-form-item label="账号：">
                        <el-input v-model.trim="modifyPwdForm.oldPwd" placeholder="平台账号" clearable></el-input>
                    </el-form-item>
                     <el-form-item label="手机号：">
                        <el-input v-model.trim="modifyPwdForm.userPhone" placeholder="平台实名认证的手机号" clearable></el-input>
                    </el-form-item>
                       <el-form-item label="验证码：">
                        <el-input style="width:30%" v-model.trim="modifyPwdForm.code"  clearable> </el-input>
                     <el-button class="codeBtn" type="primary" @click="sendCode()">发送验证码</el-button>
                    </el-form-item>
                    
                    <el-form-item label="新密码：" prop="newPwd">
                        <el-input v-model.trim="modifyPwdForm.newPwd" show-password clearable></el-input>
                    </el-form-item>
                    <el-form-item label="确认密码：" prop="newPwdAgain">
                        <el-input v-model.trim="modifyPwdForm.newPwdAgain" show-password clearable @keyup.native.enter="modifyPwd()"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="cancel">取 消</el-button>
                    <el-button type="primary" @click="modifyPwd12">确 定</el-button>
                </div>
            </el-dialog>
	  
	  <el-dialog title="修改密码" :visible.sync="modifyPwdVisible"  width="600px" :show-close="false">
	          <p style="color: #fd5353; text-align: center; margin-bottom: 20px;">{{modifyPwdTip}}</p>
	          <el-form ref="modifyPwdForm" :model="modifyPwdForm" :rules="pwdRules" label-width="100px">
	              <el-form-item label="原密码：">
	                  <el-input v-model.trim="modifyPwdForm.oldPwd" show-password ></el-input>
	              </el-form-item>
	              <el-form-item label="新密码：" prop="newPwd">
	                  <el-input v-model.trim="modifyPwdForm.newPwd" show-password ></el-input>
	              </el-form-item>
	              <el-form-item label="确认密码：" prop="newPwdAgain">
	                  <el-input v-model.trim="modifyPwdForm.newPwdAgain" show-password ></el-input>
	              </el-form-item>
	          </el-form>
	          <div slot="footer" class="dialog-footer">
	              <el-button @click="cancel">取 消</el-button>
	              <el-button type="primary" @click="modifyPwd">确 定</el-button>
	          </div>
	      </el-dialog>
	       <el-dialog title="实名认证通知" :visible.sync="auth.isAuth"  width="600px" :show-close="false">
	            <p style="color: red">1:为保护各位代理商利益，防止违法、违规，诈骗等行为 现所有代理商需完成实名认证操作方可进入后台</p><br/>
                 <p style="color: red">2:您的资料我们将依法合规保持 不泄露个人隐私，此信息仅为 出现诈骗违法行为时 配合公安局使用</p><br/>
                   <p style="color: red">3:请确保三要素信息一致，每次认证将在佣金扣除4角的手续费，请认证核实好信息再进行提交</p>
	      <p style="color: #fd5353; text-align: center; margin-bottom: 20px;">{{modifyPwdTip}}</p>
	      <el-form ref="modifyPwdForm" :model="auth"  label-width="100px">
	          <el-form-item label="姓名：" prop="nickname">
	              <el-input v-model.trim="auth.nickname" placeholder="真实姓名"></el-input>
	          </el-form-item>
	          <el-form-item label="手机号：" prop="phone">
	              <el-input v-model.trim="auth.phone"  placeholder="找回密码，绑定收款等使用"></el-input>
	          </el-form-item>
	          <el-form-item label="身份证号码：" prop="cardCode">
	              <el-input v-model.trim="auth.cardCode" placeholder="身份证号码"></el-input>
	          </el-form-item>
	          <el-form-item label="身份证正面照：">
	              <input  type="file" ref="file1">
	              <div v-if="!existBackImg"></div>
	                      <img v-else :src="frontImgUrl" alt="" width="150" height="150">  
	          </el-form-item>
	           <el-form-item label="身份证反面照：">
	              <input  type="file" ref="file2">
	               <div v-if="!existBackImg"></div>
	                      <img v-else :src="backImgUrl" alt="" width="150" height="150">  
	          </el-form-item>
	          <el-form-item label="状态">
	              <el-input v-model.trim="auth.stateName" disabled="disabled"></el-input>
	          </el-form-item>
	           <el-form-item label="审核备注：">
	              <el-input v-model.trim="auth.remark" disabled="disabled"></el-input>
	          </el-form-item>
	      </el-form>
	      <div slot="footer" class="dialog-footer">
	          <el-button @click="cancel2">取 消</el-button>
	          <el-button type="primary" @click="agentAuth">确 定</el-button>
	      </div>
	  </el-dialog>
	  <el-dialog title="实名认证通知" :visible.sync="istoAuth"  width="600px" :show-close="false">
	      <p>尊敬的代理商：为全力配合国务院联席办“断卡”行动，有效防止打击犯罪分子利用物联网卡进行违法犯罪活动，现要求所有合作商必须完成账户实名认证，实名完成后，对各合作商账号起到保护作用。</p><br/>
	       <p>1、实名认证三要素，姓名、身份证号码、手机号码必须一致通过国政通实名认证。</p><br/>
	       <p>2、请务必填写真实信息，如盗用他人信息进行实名认证，我司会追究一切法律责任。</p><br/>
	       <p>3、合作商账户后期如果出现纠纷，公司只承认该账户实名信息人为该账户实际拥有人。</p><br/>
	       <p>4、请各合作商仔细梳理自己的渠道，如发现不遵守信息安全规则的下级合作商，请主动解除合作关系，终止一切业务往来，以免影响自己的账户。</p><br/>
	       <p>5、请各合作商必按照运营商规则销售，杜绝一切风险，务必要求终端用户实名到使用人，严禁一切线上销售，禁止在新疆、西藏、云南、广西等敏感诈骗地区使用，若未遵守以上要求，出现任何违规、违法、诈骗、被投诉举报等，由此产生的一切法律责任及经济纠纷，由实名人承担。</p><br/>
	       <p>6、如有出现违法、违规行为，我司将协助公安提供该账户对应的实名认证信息，请各合作商销售过程务必谨慎，做好销售记录。</p><br/>
	      <div slot="footer" class="dialog-footer">
	          <el-button @click="cancel1">取 消</el-button>
	          <el-button type="primary" @click="istoAuthName">同 意</el-button>
	      </div>
	  </el-dialog>
	  
	  
	</div>
</template>
<script>
import {login} from '@/api/user.js'
import {sysRequest} from '@/api/customizedRequest.js'
import { mapActions } from "vuex";

import RememberAccount from '@/component/RememberAccount'
export default {
    components: {RememberAccount },
    name: 'login',
    data(){
        var checkNewPwd = (rule, value, callback) => {
            if(value.length > 16 || value.length < 6){
                return callback(new Error('请输入6 ~ 16位密码'))
            }
            callback();
        };
        var checkPwd = (rule, value, callback) => {
            if(value != this.modifyPwdForm.newPwd){
                return callback(new Error('两次输入密码不一致'))
            }
            callback();
        };
        return {
            disabled:false,
            findPassWold:false,
            loginForm: {
                accountName: '',
                pwd: ''
            },
            loginRules: {
                accountName: [
                    {required: true, message: '请输入用户名', trigger: 'blur'}
                ],
                pwd: [
                    {required: true, message: '请输入密码', trigger: 'blur'}
                ]
            },

             existBackImg: false,
            auth:{
                isAuth:false,
                nickname:'',
                phone:'',
                cardCode:'',
                stateName:'',
                remark:''
            },
             verifiedSrcList:[],
            rememberMe:false,
            backImgUrl:'',
            frontImgUrl:'',
            handImgUrl:'',
            istoAuth:false,

            //修改密码
            modifyPwdVisible:false,
            modifyPwdTip:'',
            modifyPwdForm: {
                id: '',
                oldPwd: '',
                newPwd: '',
                newPwdAgain: '',
                code:'',
                userPhone:''
            },
            pwdRules: {
                newPwd: [
                    {validator: checkNewPwd, trigger: 'blur'}
                ],
                newPwdAgain: [
                    {validator: checkPwd, trigger: 'blur'}
                ]
            },

            qrCodeUrl:window.location+'assets/alipay.png',
        }
    },
    methods: {
        findPass(){
            this.findPassWold=true;
        },
         //修改密码
        modifyPwd12(){
            this.$refs.modifyPwdForm.validate(valid => {
                if(valid) {
                    sysRequest('mould/updatePwd/phone', this.modifyPwdForm, 'post').then(res => {
                        var code = res.data.code;
                        if(code == 200){
                             for(var key in this.modifyPwdForm){
                this.modifyPwdForm[key] = '';
            }
            this.$refs['modifyPwdForm'].resetFields();
            this.modifyPwdVisible = false;
             this.findPassWold = false;
                              this.$message.success("修改成功");
                        } else{
                            this.$message.error(res.data.message);
                        }
                    });
                                               
                }
            })
        },
        sendCode(){
            var data={
                userPhone:this.modifyPwdForm.userPhone
            }
             sysRequest('mould/sms/code', data, 'post').then(res => {
                        var code = res.data.code;
                        if(code == 200){
                            this.$message.success('发送成功！');
                        }else{
                            this.$message.error(res.data.message);
                        }
                    });
        },
        agentAuth(){
            //var data =  JSON.parse(JSON.stringify(this.auth));
            var data= new FormData();
            console.log(this.$refs.file1)
            data.append('backUrl',this.$refs.file1.files[0]);
            data.append('frontUrl',this.$refs.file2.files[0]);
            data.append('nickname',this.auth.nickname);
            data.append('phone',this.auth.phone);
            data.append('cardCode',this.auth.cardCode);
            sysRequest('authNickname/agent/insert', data, 'post').then(res => {
                        var code = res.data.code;
                        if(code == 200){
                             this.$message.success('审核中，可正常登录后台！');
                             this.auth.isAuth=false;
                             this.istoAuth=false;
                        }
                        else{
                            this.$message.error(res.data.message);
                        }
                    });
        },
        ...mapActions("menu", {
            setNickName: "setNickName",
            setBtns:"setBtns"
        }),
          goIntroduction(){
            window.location.href='https://beian.miit.gov.cn/'
        },
        getAccountFormSon(data){
            if(data.account.length > 0){
                this.loginForm.accountName = data.account;
                this.loginForm.pwd = data.password;
            }
        },
        istoAuthName(){
              var dar={
                                'iccid':''
                             }
                                //查询信息
                            sysRequest('authNickname/agent/list/my',dar, 'post').then(res => {
                            var code = res.data.code;
                            if(code == 200){
                                this.auth.nickname=res.data.data.nickname;
                                this.auth.phone=res.data.data.phone;
                                this.auth.cardCode=res.data.data.cardCode;
                                this.auth.stateName=res.data.data.stateName;
                                this.auth.remark=res.data.data.remark;
                                this.existBackImg=true;
                                this.frontImgUrl = process.env.VUE_APP_IMG_URL + '/' + res.data.data.headerUrl
                                this.backImgUrl = process.env.VUE_APP_IMG_URL + '/' + res.data.data.backHeaderUrl
                                this.handImgUrl = process.env.VUE_APP_IMG_URL + '/' + res.data.data.handheldUrls
                              }
                           });

                         this.auth.isAuth=true;
        },
        handleLogin(){
            this.$refs.loginForm.validate(valid => {
                if(valid){       
                    login(this.loginForm).then(res => {                     
                        if(res.data.code == 200||res.data.code == 401){
                            localStorage.setItem('token', res.data.data.token);
                            localStorage.setItem('id', res.data.data.id);
                            localStorage.setItem('agentId', res.data.data.agentId);
                           //判断是否实名
                            if(res.data.data.isAuth==1){ // 已实名
                              this.$store.commit('menu/setToken', res.data.data.token);
                              this.$store.commit('menu/setId', res.data.data.id);
                              var nickName = res.data.data.nickName;
                              this.setNickName(nickName);
                              this.setBtns(res.data.data.actionCodes);
                              this.$router.push('AdminHome');
                              if(this.rememberMe){
                                this.setAutoCompleteData("loginAccounts", this.loginForm.accountName+'/'+this.loginForm.pwd, 8);
                              }
                            }else{
                            this.istoAuthName();
                           }


                        }
                        // else if(res.data.code == 410){
                        //     let token = res.data.data.token;
                        //     let id = res.data.data.id;
                        //     localStorage.setItem('token', token);
                        //     this.modifyPwdForm.id = id;
                        //     this.modifyPwdTip = res.data.message;
                        //     this.modifyPwdVisible = true;
                        // }
                        else if(res.data.code == 400){
                            this.$message.error(res.data.message)
                        }
                    })
                }else{
                    return;
                }
            })
        },

        //修改密码
        modifyPwd(){
            this.$refs.modifyPwdForm.validate(valid => {
                if(valid) {
                    sysRequest('sysUser/updatePwd', this.modifyPwdForm, 'post').then(res => {
                        var code = res.data.code;
                        if(code == 200){
                            let s = '<span style="color: #fd5353;">'+"为保证账户安全，请不要轻易泄露自己的账户及密码。"+'</span>'
                            this.$alert('修改密码成功！。'+s, '提示', 
                                { confirmButtonText: '确定', 
                                dangerouslyUseHTMLString: true, 
                                callback: action => {
                                    window.location.href = window.location;
                                }
                            });
                        }
                        else{
                            this.$message.error(res.data.message);
                        }
                    });
                                               
                }
            })
        },

        cancel(){
            for(var key in this.modifyPwdForm){
                this.modifyPwdForm[key] = '';
            }
            this.$refs['modifyPwdForm'].resetFields();
            this.modifyPwdVisible = false;
             this.findPassWold = false;
        },
         cancel1(){
            this.istoAuth = false;
        },
         cancel2(){
            this.auth.isAuth = false;
        },
    },

    computed: {
        showAccountsPanel: function () {
            let account = this.getAutoCompleteData('loginAccounts');
            if(account!=null && account!=undefined && account.length > 0){
                if(this.loginForm.accountName.length > 0){
                    return false;
                }else{
                    return true;
                }
            }else{
                return false;
            }
        }
    },

    created(){
        
    },

    mounted () {


    }
}
</script>

<style lang="less" scoped>
	.indexClick{
	  color: #666;
	  font-size: 14px;
	  width: 100%;
	  text-align: center;
	  margin-top: 20px;
	  text-decoration: underline;
	  cursor: pointer;
	}
	.indexClick:hover{
	  color: red;
	}
	.login {
	  width: 100%;
	  height: 100vh;
	  box-sizing: border-box;
	  display: flex;
	
	  .icon {
	    width: 32px;
	    height: 32px;
	  }
	
	  ::v-deep .el-input__inner {
	    &:focus {
	      border: 1px solid #4E83FD;
	    }
	  }
	
	  ::v-deep .el-input--medium .el-input__inner {
	    height: 40px;
	    line-height: 40px;
	  }
	
	  .left-wrap {
	    width: 520px;
	    height: 100%;
	    background: #fff;
	    background-size: cover;
	    padding: 20px;
	    box-sizing: border-box;
	    background: url("../../assets/img/lf_bg.png");
	    .left-img {
	      display: block;
	      margin: auto;
	      margin-top: 300px;
	    }
	  }
	
	  .right-wrap {
	    width: calc(100% - 520px);
	    height: 100%;
	    position: relative;
	
	    .header {
	      display: none;
	    }
	
	    .login-wrap{
	      width: 440px;
	      height: 438px;
	      border-radius: 5px;
	      overflow: hidden;
	      position: absolute;
	      left: 0;
	      right: 0;
	      top: 0;
	      bottom: 0;
	      margin: auto;
	      background-size: cover;
	      box-shadow: 0 0 10px rgba(28,76,186,.1);
	
	      .form {
	        widows: 100%;
	        height: 100%;
	        box-sizing: border-box;
	        padding: 40px 30px;
	        background: #fff;
	
	        h3 {
	          color: #555;
	          font-size: 23px;
	          text-align: center;
	          font-weight: 500;
	        }
	
	        .input-label {
	          color: #333;
	          font-size: 14px;
	          padding: 8px 0;
	          display: block;
	        }
	
	        .code {
	          display: flex;
	          justify-content: space-between;
	
	          .el-input {
	            flex: 1;
	            margin-right: 20px;
	          }
	
	          img {
	            width: 115px;
	            height: 40px;
	            cursor: pointer;
	            border-radius: 5px;
	            background: #f8f8f8 !important;
	          }
	        }
	
	        .login-btn {
	          width: 100%;
	          height: 40px;
	          border: 0;
	          color: #fff;
	          background: #4E83FD;
	        }
	      }
	    }
	  }
	}

        .login-container {
             height: 100%;
        }
        // //动态
        // @keyframes myScale
        // {
        //     0% {transform: scale(1);}
        //     100% {transform: scale(1.5);}
        // }
          .company {
            width: 40%;
            display: flex;
            position: absolute;
            bottom: 30px;
            left: 30%;
            color: #fff;
            border-top: 1px solid #fff;
            padding: 10px 0 0 10px;
            // font-family: '微软雅黑';
            .introduction {
                margin-right: 80px;
                cursor: pointer;
                &:hover {
                    color: #f66;
                }
            }
            .copy {
                span:first-child {
                    cursor: pointer;
                    &:hover {
                        color: #f66;
                    }
                }
                span:nth-child(2) {
                    cursor: pointer;
                    &:hover {
                        color: #f66;
                    }
                }
            }
        }
        .login-form {
            position: absolute;
            top: 40%;
            left: 50%;
            width: 300px;
            height: 360px;
            margin: -180px 0 0 -200px;
            padding: 50px 50px 0 50px;
            background: #fff;
            border-radius: 30px;
            .userName{
                /deep/ .el-input__inner{
                    padding-left:40px;
                    border:none;
                    border-bottom:1px solid #DCDFE6;
                    border-radius:0;
                }
                /deep/.el-input__icon{
                    font-size:20px;
                    color:#2BAEC3;
                }
            }
            h1 {
                text-align: center;
                color: #128bf1;
                font-size: 26px;
                margin-bottom: 20px;
            }

            .login-btn {
                width: 100%;
                margin-top: 15px;
                background: #2BAEC3;
                border-color: #2BAEC3;
            }
            .link {
                float: right;
                margin: 10px -26px 0 0;
            }
        }

        .showRememberAccount{
            position: absolute;
            box-sizing: border-box;
            width: 100%;
            background: #f7f7f7;
            border: 1px solid #dcdfe6;
            border-radius: 5px;
            z-index: 9;
        }

        .qrcode-show{
            width: 300px;
            a{
                font-size: 14px;
            }

            a:last-child{
                margin-left: 132px;
            }

        }
.el-button--primary {
    color: #FFF;
    background-color: #0c64eb;
    border-color: #409EFF;
}
    
.login-form h1[data-v-a49090ce] {
    text-align: center;
    color: #2BAEC3;
    font-size: 30px;
    margin-bottom: 18px;
}


</style>

